/**
 * order item endpoint instance
 * instantiate order item api class with a different api path
 */
import { CashOutEndpoints } from '@/modules/order-management/cashout-order/api/cashoutEndpoints'
import { ICashOutOrder } from '@/modules/order-management/cashout-order/types/cashoutTypes'

export const cashOutOrderEndpoint = new CashOutEndpoints<ICashOutOrder>()
